import { DEFAULT_LANGUAGE } from '../constants';

/** Возвращает подстроку обозначающую язык карты. Подстрока добавляется в url запроса яндекс карт */
export var getLanguage = function getLanguage(apiUrl) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LANGUAGE;
  if (apiUrl.indexOf('lang=') === -1) {
    return "&lang=".concat(language, "-RU");
  }
  return '';
};